import commonDataAccess from "../commonDataAccess";
import { IFilter } from "../../@redux/listRedux";
import { formatFilterForQueryParam } from "src/common/service";

class AuditChangeLogDataAccess {
  getAuditChangeLogList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
  }) => {
    let _filters = formatFilterForQueryParam(params?.filters);

    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
    };

    return commonDataAccess.getData("auditChange/getList", parameters);
  };

  
  getCheckAuditChangeLogList = (params: {
    pageNo;
    pageSize;
    sortData;
    filters: Array<IFilter>;
    typeProcedure?: number;
    entityType?: string;
  }) => {
    let _filters = formatFilterForQueryParam(params?.filters);

    let parameters = {
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      sortPreference: params.sortData,
      ..._filters,
      typeProcedure: params.typeProcedure || 0,
       ...(params.entityType ? { entityType: params.entityType } : {}),
    };

    return commonDataAccess.getData("auditChange/check/getList", parameters);
  };

  updateAuditLog = (id: any, payload: any) => {
    return commonDataAccess.putData("auditChange/update", payload, {
      id: id,
    });
  };
  deleteAuditLogByIds = (ids: string) => {
    return commonDataAccess.deleteData(`auditChange/delete/`, {
      ids: ids,
    });
  };
}

export default new AuditChangeLogDataAccess();
